export default {
  red: "Rouge",
  white: "Blanc",
  rose: "Rosé",
  fizzy: "Pétillant"
};
